/* eslint-disable no-shadow,no-param-reassign,no-mixed-operators */
import i18n from '../../i18n/i18n-config';
import eventBus from '../../util/event-bus';

const state = {
  confirmDialog: {
    isOpen: false,
  },
  snackbar: {
    isOpen: false,
  },
  loading: false,
};

const getters = {};

const mutations = {
  openConfirmDialog(state, payload) {
    if (!payload) {
      payload = {};
    }
    state.confirmDialog = {
      isOpen: true,
      cancelText: payload.cancelText ? payload.cancelText : i18n.t('cancel'),
      confirmText: payload.confirmText ? payload.confirmText : i18n.t('confirm'),
      body: payload.body,
      title: payload.title ? payload.title : i18n.t('are_you_sure'),
    };
  },

  closeConfirmDialog(state, isConfirmed) {
    state.confirmDialog.isOpen = false;
    eventBus.$emit('confirmDialogClosed', isConfirmed);
  },

  openSnackbar(state, payload) {
    if (typeof payload === 'string') {
      state.snackbar = {
        isOpen: true,
        text: payload,
      };
    } else {
      state.snackbar = {
        isOpen: true,
        text: typeof payload === 'string' ? payload : payload.text,
        action: payload.action,
        link: payload.link,
        timeout: payload.timeout,
      };
    }
  },

  closeSnackbar(state) {
    state.snackbar.isOpen = false;
  },

  showProgress(state) {
    state.loading = true;
  },

  hideProgress(state) {
    state.loading = false;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
